import {
  BarChart3,
  CheckSquare,
  ClipboardCheck,
  FileCog,
  FileInput,
  FileSearch,
  FileStack,
  FileText,
  History,
  LayoutDashboard,
  type LucideIcon,
  Map,
  Printer,
  QrCode,
  Rocket,
  ScanText,
  ShieldAlert,
  ShieldCheck,
  Stamp,
  Users,
  Workflow
} from 'lucide-react';
import type { RoleId } from '../types/notice';

export interface AdminNavItem {
  path: string;
  label: string;
  icon: LucideIcon;
  roles: RoleId[] | 'all';
}

export interface AdminNavGroup {
  group: string;
  items: AdminNavItem[];
}

export const adminNav: AdminNavGroup[] = [
  {
    group: 'মনিটরিং',
    items: [{ path: '/admin', label: 'এক্সিকিউটিভ ড্যাশবোর্ড', icon: LayoutDashboard, roles: 'all' }]
  },
  {
    group: 'নোটিশ প্রক্রিয়াকরণ',
    items: [
      { path: '/admin/notices', label: 'নোটিশ ব্যবস্থাপনা', icon: FileStack, roles: 'all' },
      { path: '/admin/upload', label: 'নতুন নোটিশ আপলোড', icon: FileInput, roles: ['super', 'sysadmin', 'operator'] },
      { path: '/admin/ocr', label: 'AI/OCR তথ্য সংগ্রহ', icon: ScanText, roles: ['super', 'sysadmin', 'operator'] },
      { path: '/admin/review', label: 'তথ্য যাচাই ও সংশোধন', icon: FileSearch, roles: ['super', 'sysadmin', 'operator'] },
      { path: '/admin/validate', label: 'প্রসিকিউশন তথ্য যাচাই', icon: ClipboardCheck, roles: ['super', 'validator'] },
      { path: '/admin/approval', label: 'নোটিশ অনুমোদন', icon: Stamp, roles: ['super', 'approver'] }
    ]
  },
  {
    group: 'নিরাপদ নোটিশ',
    items: [
      { path: '/admin/generate', label: 'নিরাপদ নোটিশ তৈরি', icon: ShieldCheck, roles: ['super', 'approver', 'dispatch', 'sysadmin'] },
      { path: '/admin/sample-notice', label: 'নমুনা ডিএমপি নোটিশ', icon: FileText, roles: 'all' },
      { path: '/admin/qr-data', label: 'QR কোড তথ্যসেট', icon: QrCode, roles: ['super', 'sysadmin', 'approver', 'monitor', 'dispatch'] },
      { path: '/admin/dispatch', label: 'প্রিন্ট ও ডাকযোগে প্রেরণ', icon: Printer, roles: ['super', 'dispatch'] },
      { path: '/admin/status', label: 'নোটিশের অবস্থা ব্যবস্থাপনা', icon: CheckSquare, roles: ['super', 'sysadmin', 'approver'] }
    ]
  },
  {
    group: 'নজরদারি ও রিপোর্ট',
    items: [
      { path: '/admin/fraud', label: 'প্রতারণা রিপোর্ট', icon: ShieldAlert, roles: ['super', 'monitor'] },
      { path: '/admin/reports', label: 'রিপোর্ট ও বিশ্লেষণ', icon: BarChart3, roles: ['super', 'sysadmin', 'approver', 'monitor'] },
      { path: '/admin/audit', label: 'সিস্টেম অডিট লগ', icon: History, roles: ['super', 'sysadmin', 'monitor'] }
    ]
  },
  {
    group: 'প্রশাসন',
    items: [
      { path: '/admin/templates', label: 'নোটিশ টেমপ্লেট', icon: FileCog, roles: ['super', 'sysadmin'] },
      { path: '/admin/users', label: 'ইউজার ও রোল', icon: Users, roles: ['super'] }
    ]
  },
  {
    group: 'উপস্থাপনা',
    items: [
      { path: '/admin/process', label: 'প্রক্রিয়া চিত্র', icon: Workflow, roles: 'all' },
      { path: '/admin/roadmap', label: 'ভবিষ্যৎ সম্প্রসারণ', icon: Rocket, roles: 'all' }
    ]
  }
];

export const allNavItems: AdminNavItem[] = adminNav.flatMap((g) => g.items);

export const hubIcon = Map;
